<style>
	    .c3-axis-y .tick, .c3-axis-y-label {
        fill: #a9a9a9 !important;
        font-size: 12px;
    }

    .c3-axis-x .tick, .c3-axis-x-label {
        fill: #a9a9a9 !important;
        font-size: 12px;
    }

    .c3 line, .c3 path {
        stroke: #a9a9a9;
    }

    .c3-xgrid-line line {
        stroke: #a9a9a9;
    }

    .c3-ygrid-line line {
        stroke: green;
    }


    .fc-rows td.fc-widget-content > div:first-of-type {
		/*height:100px;*/
    }

    .popover-title {
        background-color: #fff;
    }

    .fc-resource-area.fc-widget-content {
        width:155px;
    }

   
</style>

<template>

   	<div class="row">
        <div class="col-sm-4">
            <div class="ibox">
                <div class="ibox-content">
                    <span class="text-muted small float-right">Showing 1 to {{tasks.length}} of {{totalTasks}} </span>
                    <h2>Tasks</h2>
                    <div class="input-group">
                        <input v-model="search_string" type="text" placeholder="Search project" class="input form-control">
                        <span class="input-group-btn">
                                <button type="button" class="btn btn btn-primary"> <i class="fa fa-search" v-show="!searching"></i> <i class="fa fa-spinner fa-spin" v-show="searching"></i> Search</button>
                        </span>
                    </div>

                    <ul class="sortable-list connectList agile-list ui-sortable" id='external-events'>
                    	<template v-for="task in tasks">
                    		<task :task="task"></task>  
                    	</template>
                    	    
                    </ul>

                </div>
            </div>
        </div>   

         <div class="col-sm-8">
            <div class="ibox">
                <div class="ibox-content" style="padding: 13px 0px 0px 0px;" v-if="!loading">
                    <assignments-chart :data="assignments"></assignments-chart>
                </div>
            </div>

            <div class="ibox">
                <div class="ibox-content" v-if="!loading">
                	<assignment :resources="resources"></assignment>
                    <div id="calendar"></div>
                </div>
            </div>
        </div>   
   	</div>
</template>

<script>
/*require('jquery-ui/ui/widgets/draggable');
require('jquery-ui/ui/widgets/droppable');
require('jquery-ui/ui/widgets/sortable');*/

    export default {
        data: function () {
            return {
                tasks: [],
                current_page: 0,
                totalTasks: 0,
                loading: true,
                search_string: '',
                searching: false,
                resources: [],
                assignments: [],
                period: {start: '2016-02-29', end: '2016-03-05'}
            }
        },
         route: {
        	
        	data: function() {
        		var that = this;
				var clientFilter = '';

				return Promise.all([
			      
			    	client({path: '/tasks/unscheduled'}).then(
						function(response) {
							return response.entity
						}
					),
					client({path: '/calendar/resources'}).then(
						function(response) {
							return response.entity.data
						}
					)

			    ]).then(function(data) {
			    	return {
			    		tasks: data[0].data,
			    		current_page: data[0].current_page,
			    		totalTasks:  data[0].total,
			    		resources: data[1]
			    	}
			    });

        		
        	}
        },
        events: {
        	'destroy-task': function(task) {
        		var index = this.tasks.indexOf(task); 
        		this.tasks.splice(index, 1)
        		var that = this;

                this.$emit('update-assignments');
        	},
            'update-assignments': function(period) {
                var that = this;

                //If user has changed calendar days then we get notified here
                if (period) {
                    this.period.start = period.start;
                    this.period.end = period.end; 
                }

                client({path: '/graphs/assignments', params: {'start': that.period.start, 'end': that.period.end}}).then(
                    function(response) {
                        that.$set('assignments', response.entity);
                    }
                )
            }
        },
        components: {
            'task': require('./_task.vue').default,
            'assignments-chart': require('../graphs/Assignments.vue').default,
            'assignment': require('../form/calendars/Assignment.vue').default
        }
    }
</script>